import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	editIcon: {
		color: themeColors.colors.system.gray[700],
		fontSize: "20px"
	},
	listItemButton: {
		background: themeColors.colors.system.gray[100],
		opacity: "0.7",
		width: "64px",
		height: "64px",
		borderRadius: "8px",
		gap: "8px",
		"&:hover": {
			backgroundColor: themeColors.colors.system.gray[200]
		}
	},
	listItemMoreOptions: {
		background: themeColors.colors.system.gray[100],
		opacity: 0.8,
		borderRadius: "8px",
		gap: "8px",
		"&:hover": {
			backgroundColor: themeColors.colors.system.gray[200]
		},
		minWidth: "64px",
		width: "64px",
		height: "64px",
		color: themeColors.colors.system.gray[700],
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	}
}))

export default useStyles
